(function () {
  function labelWishlistWidget(el) {
    if (!el || el.hasAttribute('data-label')) return;
    el.setAttribute('data-label', window.reebokWishlistLabel || 'Add to Wishlist');
  }

  document.querySelectorAll('.swym-atw-button-container').forEach(labelWishlistWidget);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.swym-atw-button-container')) {
          labelWishlistWidget(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.swym-atw-button-container').forEach(labelWishlistWidget);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
